module.exports = __webpack_public_path__ + "images/sprites/ui/icon_phone_skyblue_defe02ec716f207586d0992410d593a5.png";